import { RouteEnum } from '@/constants/enums/RouteEnum';
import { env } from '@/env';
import adMgmShareKey from '@/middleware/adMgmShareKey';
import auth from '@/middleware/auth';
import device from '@/middleware/device';
import { getTokenPayload, loginState } from '@/utils/token';
import type { RouteRecordRaw } from 'vue-router';

/**
 * 登入類型路由
 */
export const loginTypeRoutes: RouteRecordRaw[] = [
  /**
   * 登入註冊頁
   */
  {
    path: '/login',
    name: RouteEnum.Login,
    component: () => import('@/views/login/LoginView.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth, adMgmShareKey, device]
    },
    beforeEnter: async (to) => {
      const userStore = useUserStore();

      // 解析 JWT Token，取得會員站台版本
      const tokenPayload = getTokenPayload();
      const userSiteVersion = computed<string>(() => tokenPayload.siteVersion || 'V1');
      const isV2OfficialUser = computed<boolean>(() => userSiteVersion.value === 'V2');

      if (loginState() && isV2OfficialUser.value) {
        // 2026/07/20 之後註冊的會員，將導向 V2 網站
        window.location.href = env.officialV2Url;
        return false;
      }

      if (userStore.hasLoginCondition) {
        return { name: RouteEnum.Index };
      }
    }
  },
  /**
   * 英語中學 登入註冊頁
   */
  {
    path: '/loginJunior',
    name: RouteEnum.LoginJunior,
    component: () => import('@/views/login/LoginJuniorView.vue'),
    meta: {
      layout: 'NoLayout',
      middleware: [auth, adMgmShareKey, device]
    }
  },
  /**
   * 行銷廣告用登入頁「音樂＆電影」
   */
  {
    path: '/loginMusicTube',
    name: RouteEnum.LoginMusicTube,
    component: () => import('@/views/login/LoginMusicTubeView.vue'),
    meta: {
      middleware: [auth, adMgmShareKey, device],
      layout: 'NoLayout'
    }
  },
  /**
   * 行銷廣告用登入頁「通用型」(暫時停用)
   */
  // {
  //   path: '/loginCommon',
  //   name: RouteEnum.LoginCommon,
  //   component: () => import('@/views/LoginCommonView.vue'),
  //   meta: {
  //     middleware: [auth, adMgmShareKey, device],
  //     layout: 'NoLayout'
  //   }
  // },
  /**
   * 行銷廣告用登入頁「文章導讀」
   */
  {
    path: '/loginReading',
    name: RouteEnum.LoginReading,
    component: () => import('@/views/login/LoginReadingView.vue'),
    meta: {
      middleware: [auth, adMgmShareKey, device],
      layout: 'NoLayout'
    }
  },
  /**
   * LINE 登入綁定頁
   */
  {
    path: '/lineBinding',
    name: RouteEnum.LineBinding,
    component: () => import('@/views/login/LineBinding.vue'),
    meta: {
      middleware: [auth, adMgmShareKey, device],
      layout: 'NoLayout'
    }
  }
];
